import apiCall from "./api";


export const OrgCreate =(org_data) => {

    return apiCall({
      method: 'POST',
      endpoint: `org/organisation/`,
      // endpoint: `core/resource/?${queryString}`,
      data: org_data,
  });
};

export const OrgGet =() => {

    return apiCall({
      method: 'GET',
      endpoint: `org/organisation/`,
      // endpoint: `core/resource/?${queryString}`,
    //   data: org_data,
  });
};

export const OrgGetDetail =(orgId) => {

  return apiCall({
    method: 'GET',
    endpoint: `org/organisation/${orgId}/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: org_data,
});
};

export const OrgUpdate =(id,org_data) => {

    return apiCall({
      method: 'PUT',
      endpoint: `org/organisation/${id}/`,
      // endpoint: `core/resource/?${queryString}`,
      data: org_data,
  });
};

export const OrgMetaGet=(id) => {

  return apiCall({
    method: 'GET',
    endpoint: `org/organisation-meta/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
});
};

export const OrgMetaUpdate =(id,org_data) => {

  return apiCall({
    method: 'PUT',
    endpoint: `org/organisation-meta/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    data: org_data,
});
};


export const ArticlePut =(id,article_data) => {

  return apiCall({
    method: 'PUT',
    endpoint: `cms/articles/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    data: article_data,
});
};

export const ArticleCreate =(article_data) => {

    return apiCall({
      method: 'POST',
      endpoint: `cms/articles/`,
      // endpoint: `core/resource/?${queryString}`,
      data: article_data,
  });
};

export const ArticleGet =() => {

    return apiCall({
      method: 'GET',
      endpoint: `cms/articles/`,
      // endpoint: `core/resource/?${queryString}`,
    //   data: article_data,
  });
};


export const ArticleGetBatch =(article_data) => {
  return apiCall({
    method: 'GET',
    endpoint: `cms/articles/`,
    // endpoint: `core/resource/?${queryString}`,
    data: article_data,
});
};

export const ArticleGetDetail =(articleId) => {

  return apiCall({
    method: 'GET',
    endpoint: `cms/articles/${articleId}`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: article_data,
});
};

export const NewsCreate =(news_data) => {

    return apiCall({
      method: 'POST',
      endpoint: `cms/news/`,
      // endpoint: `core/resource/?${queryString}`,
      data: news_data,
  });
};


export const NewsPut =(id,news_data) => {

  return apiCall({
    method: 'PUT',
    endpoint: `cms/news/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    data: news_data,
});
};

export const NewsGet =() => {

  return apiCall({
    method: 'GET',
    endpoint: `cms/news/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: article_data,
});
};

export const NewsLatestGet =() => {

  return apiCall({
    method: 'GET',
    endpoint: `cms/news/latest/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: article_data,
});
};

export const ResourceCreate =(article_data) => {

    return apiCall({
      method: 'POST',
      endpoint: `cms/resources/`,
      // endpoint: `core/resource/?${queryString}`,
      data: article_data,
  });
};

export const ResourceGet =() => {

    return apiCall({
      method: 'GET',
      endpoint: `cms/resources/`,
      // endpoint: `core/resource/?${queryString}`,
    //   data: article_data,
  });
};

export const ResourceGetDetail =(articleId) => {

  return apiCall({
    method: 'GET',
    endpoint: `cms/resources/${articleId}`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: article_data,
});
};

export const ResourcePut =(id,article_data) => {

    return apiCall({
      method: 'PUT',
      endpoint: `cms/resources/${id}/`,
      // endpoint: `core/resource/?${queryString}`,
      data: article_data,
  });
};


export const CampaignCreate =(campaign_data) => {

    return apiCall({
      method: 'POST',
      endpoint: `org/campaign/`,
      // endpoint: `core/resource/?${queryString}`,
      data: campaign_data,
  });
};

export const CampaignGet =() => {

  return apiCall({
    method: 'GET',
    endpoint: `org/campaign/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: org_data,
});
};

export const CampaignGetDetail =(campaignId) => {

return apiCall({
  method: 'GET',
  endpoint: `org/campaign/${campaignId}/`,
  // endpoint: `core/resource/?${queryString}`,
//   data: org_data,
});
};

export const CampaignUpdate =(id,campaign_data) => {

  return apiCall({
    method: 'PUT',
    endpoint: `org/campaign/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    data: campaign_data,
});
};

export const CampaignDelete =(id,campaign_data) => {

  return apiCall({
    method: 'DELETE',
    endpoint: `org/campaign/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    data: campaign_data,
});
};

export const ProjectCreate =(project_data) => {

    return apiCall({
      method: 'POST',
      endpoint: `org/project/`,
      // endpoint: `core/resource/?${queryString}`,
      data: project_data,
  });
};
export const ProjectGet =() => {

    return apiCall({
      method: 'GET',
      endpoint: `org/project/`,
      // endpoint: `core/resource/?${queryString}`,
    //   data: org_data,
  });
};

export const ProjectGetDetail =(projectId) => {

  return apiCall({
    method: 'GET',
    endpoint: `org/project-detail/${projectId}/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: org_data,
});
};

export const ProjectUpdate =(id,project_data) => {

    return apiCall({
      method: 'PUT',
      endpoint: `org/project/${id}/`,
      // endpoint: `core/resource/?${queryString}`,
      data: project_data,
  });
};



export const StaffCreate =(staff_data) => {

    return apiCall({
      method: 'POST',
      endpoint: `org/staff/`,
      // endpoint: `core/resource/?${queryString}`,
      data: staff_data,
  });
};

export const StaffGet =() => {

    return apiCall({
      method: 'GET',
      endpoint: `org/staff/`,
      // endpoint: `core/resource/?${queryString}`,
    //   data: org_data,
  });
};

export const StaffGetGrouped =() => {

  return apiCall({
    method: 'GET',
    endpoint: `org/staff-by-group/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: org_data,
});
};

export const StaffGetDetail =(staffId) => {

  return apiCall({
    method: 'GET',
    endpoint: `org/staff/${staffId}/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: org_data,
});
};

export const StaffUpdate =(id,staff_data) => {

    return apiCall({
      method: 'PUT',
      endpoint: `org/staff/${id}/`,
      // endpoint: `core/resource/?${queryString}`,
      data: staff_data,
  });
};




export const VolunteerCreate =(staff_data) => {

  return apiCall({
    method: 'POST',
    endpoint: `org/volunteer/`,
    // endpoint: `core/resource/?${queryString}`,
    data: staff_data,
});
};

export const VolunteerGet =() => {

  return apiCall({
    method: 'GET',
    endpoint: `org/volunteer/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: org_data,
});
};

export const VolunteerGetGrouped =() => {

return apiCall({
  method: 'GET',
  endpoint: `org/volunteer-by-group/`,
  // endpoint: `core/resource/?${queryString}`,
//   data: org_data,
});
};

export const VolunteerGetDetail =(volunteerId) => {

return apiCall({
  method: 'GET',
  endpoint: `org/volunteer/${volunteerId}/`,
  // endpoint: `core/resource/?${queryString}`,
//   data: org_data,
});
};

export const VolunteerUpdate =(id,volunteer_data) => {

  return apiCall({
    method: 'PUT',
    endpoint: `org/volunteer/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    data: volunteer_data,
});
};






export const CategoryCreate =(category_data) => {

  return apiCall({
    method: 'POST',
    endpoint: `org/category/`,
    // endpoint: `core/resource/?${queryString}`,
    data: category_data,
});
};

export const CategoryGet =() => {

  return apiCall({
    method: 'GET',
    endpoint: `org/category/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: article_data,
});
};

export const CategoryGetDetail =(categoryId) => {

return apiCall({
  method: 'GET',
  endpoint: `org/category/${categoryId}/`,
  // endpoint: `core/resource/?${queryString}`,
//   data: article_data,
});
};


export const CategoryPut =(id,category_data) => {

  return apiCall({
    method: 'PUT',
    endpoint: `org/category/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    data: category_data,
});
};

export const Categorydelete =(id) => {

  return apiCall({
    method: 'DELETE',
    endpoint: `org/category/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    // data: category_data,
});
};

// cms/campaign/


export const SubCategoryCreate =(category_data) => {

  return apiCall({
    method: 'POST',
    endpoint: `org/subcategory/`,
    // endpoint: `core/resource/?${queryString}`,
    data: category_data,
});
};

export const SubCategoryGet =() => {

  return apiCall({
    method: 'GET',
    endpoint: `org/subcategory/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: article_data,
});
};

export const SubCategoryGetDetail =(subcategoryId) => {

return apiCall({
  method: 'GET',
  endpoint: `org/subcategory/${subcategoryId}/`,
  // endpoint: `core/resource/?${queryString}`,
//   data: article_data,
});
};

// 


// subcategory-by-category
export const SubCategoryByAdminGetDetail =() => {

  return apiCall({
    method: 'GET',
    endpoint: `org/subcategory-by-admin/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: article_data,
  });
  };


  export const SubCategoryByCategoryGetDetail =(subcategoryId) => {

    return apiCall({
      method: 'GET',
      endpoint: `org/subcategory-by-category/${subcategoryId}/`,
      // endpoint: `core/resource/?${queryString}`,
    //   data: article_data,
    });
    };

export const SubCategoryPut =(id,subcategory_data) => {

  return apiCall({
    method: 'PUT',
    endpoint: `org/subcategory/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    data: subcategory_data,
});
};

export const SubCategoryDelete =(id) => {

  return apiCall({
    method: 'DELETE',
    endpoint: `org/subcategory/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    // data: subcategory_data,
});
};

export const GetUploadUrl =(formData) => {
  console.log(formData)
  return apiCall({
    method: 'POST',
    isMultipart: true,
    endpoint: `cms/ftp-files/`,
    body: formData,
});
};




export const PartnerCreate =(partner_data) => {

  return apiCall({
    method: 'POST',
    endpoint: `org/partner/`,
    // endpoint: `core/resource/?${queryString}`,
    data: partner_data,
});
};

export const PartnerGet =() => {

  return apiCall({
    method: 'GET',
    endpoint: `org/partner/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: article_data,
});
};

export const PartnerGetDetail =(partnerId) => {

return apiCall({
  method: 'GET',
  endpoint: `org/partner/${partnerId}`,
  // endpoint: `core/resource/?${queryString}`,
//   data: article_data,
});
};

export const PartnerPut =(id,partner_data) => {

  return apiCall({
    method: 'PUT',
    endpoint: `org/partner/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    data: partner_data,
});
};




export const FunderCreate =(partner_data) => {

  return apiCall({
    method: 'POST',
    endpoint: `org/funder/`,
    // endpoint: `core/resource/?${queryString}`,
    data: partner_data,
});
};

export const FunderGet =() => {

  return apiCall({
    method: 'GET',
    endpoint: `org/funder/`,
    // endpoint: `core/resource/?${queryString}`,
  //   data: article_data,
});
};

export const FunderGetDetail =(partnerId) => {

return apiCall({
  method: 'GET',
  endpoint: `org/funder/${partnerId}`,
  // endpoint: `core/resource/?${queryString}`,
//   data: article_data,
});
};

export const FunderPut =(id,partner_data) => {

  return apiCall({
    method: 'PUT',
    endpoint: `org/funder/${id}/`,
    // endpoint: `core/resource/?${queryString}`,
    data: partner_data,
});
};